import CableApp from 'actioncable'

// Leaderboard ticks are signal-only cable messages ("board X moved"); content
// never rides the cable. Broadcast by Leaderboards::Broadcaster on the public
// LeaderboardChannel stream; consumers refetch the leaderboard JSON endpoints.
export interface LeaderboardTick {
    board?: string
    t?: number
}

type TickListener = (tick: LeaderboardTick) => void

const LEADERBOARD_TICK_MESSAGE = 'leaderboard tick'

// One refcounted subscription per tab no matter how many surfaces listen.
const tickListeners = new Set<TickListener>()
let subscription: { unsubscribe: () => void } | null = null

function dispatchLeaderboardTick(tick: LeaderboardTick) {
    tickListeners.forEach(listener => {
        try {
            listener(tick)
        } catch (error) {
            console.error('>>> leaderboard tick listener error', error)
        }
    })
}

function ensureSubscription() {
    if (subscription || !CableApp?.cable) return

    let connectedOnce = false
    subscription = CableApp.cable.subscriptions.create(
        { channel: 'LeaderboardChannel' },
        {
            connected: () => {
                if (connectedOnce) {
                    dispatchLeaderboardTick({})
                }
                connectedOnce = true
            },
            received: (data: { message?: string; board?: string; t?: number }) => {
                if (data?.message !== LEADERBOARD_TICK_MESSAGE) return
                dispatchLeaderboardTick(data)
            },
        },
    )
}

export function subscribeLeaderboardTicks(listener: TickListener): () => void {
    tickListeners.add(listener)
    ensureSubscription()
    return () => {
        tickListeners.delete(listener)
        if (tickListeners.size === 0 && subscription) {
            subscription.unsubscribe()
            subscription = null
        }
    }
}
